import { Injectable } from '@angular/core';
import { EntityUIQuery, ID, QueryEntity } from '@datorama/akita';
import { ActionTrackingUI } from './action-tracking.model';
import { ActionTrackingsState, ActionTrackingsStore, ActionTrackingUIState } from './action-tracking.store';

@Injectable({ providedIn: 'root' })
export class ActionTrackingsQuery extends QueryEntity<ActionTrackingsState> {
  override ui: EntityUIQuery<ActionTrackingUIState>;

  constructor(protected override store: ActionTrackingsStore) {
    super(store);
    this.createUIQuery();
  }

  getUiState(txnUuid: string | ID) {
    return this.ui.getEntity(txnUuid);
  }

  getActionTrackingByTxn(txnUuid: string) {
    return this.getEntity(txnUuid);
  }

  selectActionTrackingByTxn(txnUuid: string) {
    return this.selectEntity(txnUuid);
  }

  selectUIState<K extends keyof ActionTrackingUI>(id: string | ID, property: K) {
    return this.ui.selectEntity(id, property);
  }
}
